<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>Rekap Absensi</strong>
          </p>
        </template>
        <CRow class="mb-4">
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4 mr-3" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
            <b-button variant="danger" class="mb-4 mr-3" @click="printSummary()">
              <CIcon name="cil-cloud-download" />
              Summary
            </b-button>
            <!-- <b-button variant="success" class="mb-4" v-b-modal.modal-input-csv> <CIcon name="cil-plus" /> Upload File CSV </b-button> -->
          </CCol>
          <CCol col="4">
            <b-form-group label="Periode" label-for="periode" class="my-0">
              <Multiselect
                id="periode"
                v-model="filter.periode"
                :options="listPeriodeGaji"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Periode --"
                label="namaPeriode"
                track-by="id"
                @input="hitungTanggal()"
              ></Multiselect>
            </b-form-group>
          </CCol>
          <CCol col="3">
            <b-form-group label="Bulan - tahun" label-for="bulanTahun" class="my-0">
              <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
            </b-form-group>
          </CCol>
          <CCol col="3">
            <b-form-group label="Cabang" label-for="cabang" class="my-0">
              <Multiselect
                id="cabang"
                v-model="filter.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Cabang --"
                label="namaCabang"
                track-by="cabangId"
                @input="hitungTanggal()"
              ></Multiselect>
            </b-form-group>
          </CCol>
          <CCol col="2" style="margin-bottom: 6px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">Reset</b-button>
            </div>
          </CCol>
          <CCol col="12" class="">
            <small class="mx-2">{{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ( {{ filter.jmlHari }} hari)</small>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Detail Data'" v-b-modal.modal-detail @click="(data = item), (detail = !detail)"><CIcon name="cil-info" /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-detail
      :data="data"
      :detail="detail"
      :periode_gaji="periode_gaji"
      :fetch_data="{
        ...filter,
        halaman: currentPage - 1,
        jumlah: perPage,
        dataKaryawanId: data.dataKaryawanId,
      }"
    />
    <modal-input :listKaryawan="listKaryawan" :listShift="listCuti" @alertFromChild="triggerAlert($event)" />
    <modal-input-csv />
  </CRow>
</template>

<script>
import modalDetail from "./modalDetail.vue";
import modalInput from "./modalInput.vue";
import modalInputCsv from "./modalInputCsv.vue";
import debounce from "lodash/debounce";

export default {
  components: {
    modalInput,
    modalInputCsv,
    modalDetail,
  },
  name: "rekapAbsensi",
  data() {
    return {
      bulan: null,
      tahun: null,
      detail: false,
      data: {},
      listPeriodeGaji: [],
      listCuti: [],
      listKaryawan: [],
      items: [],
      filter: {
        periode: null,
        bulanTahun: null,
        cabang: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: "0",
      },
      periode_gaji: null,
      listCabang: [],
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "width: 45%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "totalBerangkat",
          label: this.$store.state.table.totalBerangkat,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "jumlahIjin",
          label: this.$store.state.table.jumlahIjin,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "masukTelat",
          label: this.$store.state.table.masukTelat,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 5%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  async mounted() {
    await this.getPeriodeGaji();
    await this.getMitra();
    await this.reset();

    // this.getDatas();
    this.getKaryawan();
    this.getShift();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    filter: {
      deep: true,
      handler() {
        this.debounceGetDatas();
      },
    },
  },
  methods: {
    debounceGetDatas: debounce(function () {
      this.getDatas();
    }, 1000),
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      this.debounceGetDatas();
    },
    async printSummary() {
      let vm = this;
      let kode = vm.$store.state.kode_client ? vm.$store.state.kode_client : null;
      let ip = vm.$be;

      if (!vm.$be.includes("localhost")) {
        ip = kode ? vm.$be + "api-" + kode + "/" : vm.$be;
      }

      let params = new URLSearchParams();

      if (vm.filter.tglAwal) {
        params.append("tglAwal", vm.$moment(vm.filter.tglAwal).format("YYYY-MM-DD"));
      }
      if (vm.filter.tglAkhir) {
        params.append("tglAkhir", vm.$moment(vm.filter.tglAkhir).format("YYYY-MM-DD"));
      }
      if (vm.$store.state.mitra_aktif?.id) {
        params.append("mitraId", vm.$store.state.mitra_aktif.id);
      }
      if (vm.filter.cabang?.cabangId) {
        params.append("cabangId", vm.filter.cabang.cabangId);
      }

      let url = ip + "absensiKaryawanMobile/summary" + (params.toString() ? "?" + params.toString() : "");
      // console.log(url);
      window.open(url, "_blank");
    },
    async hitungTanggal() {
      const vm = this;

      // ambil bulanTahun
      const bulanTahun = vm.$moment(vm.filter.bulanTahun);
      const monthYear = bulanTahun.format("MM-YYYY");

      // kalau periode tidak ada → default ke awal & akhir bulan
      if (!vm.filter.periode) {
        vm.filter.tglAwal = bulanTahun.startOf("month").format("YYYY-MM-DD");
        vm.filter.tglAkhir = bulanTahun.endOf("month").format("YYYY-MM-DD");
        vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "days") + 1;
        vm.getDatas();
        return;
      }

      // kalau periode ada → logic lama tetap
      const periode = vm.filter.periode;
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");

      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;

      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");

      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        let awal = periode.xtanggalAwal;
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }

      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }

      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "days") + 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listRekapAbsensi = await vm.$axios.post("absensiKaryawanMobile/rekapAbsenPerBulanPerHalaman", {
        ...vm.filter,
        cabangId: vm.filter.cabang?.cabangId,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listRekapAbsensi", listRekapAbsensi);
      vm.items =
        listRekapAbsensi.data.status == 200
          ? listRekapAbsensi.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.absensiKaryawanMobileId,
                namaMitra: x.namaMitra || " - ",
                keluarTelat: x.keluarTelat || " - ",
                istirahatTelat: x.istirahatTelat || " - ",
              };
            })
          : [];
      vm.totalRows = Number(listRekapAbsensi.data.count);
      vm.loading = false;
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      // console.log("listPeriodeGaji : ", listPeriodeGaji);
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                id: x.periodeGajiMitraId,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})${x.isBpjs ? ", BPJS" : ""}`,
              };
            })
          : [];
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.post("dataKaryawan/filterDataKaryawanPerHalaman", {
        halaman: 0,
        jumlah: 1000,
      });
      vm.listKaryawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                namaKaryawan: x.namaKaryawan + " - " + x.penempatan,
              };
            })
          : [];
    },
    async getShift() {
      let vm = this;
      vm.listCuti = [];
      let listCuti = await vm.$axios.post("masterShift/list");
      // console.log(listCuti);
      vm.listCuti =
        listCuti.data.status == 200
          ? listCuti.data.data.map((item) => {
              return { ...item, value: item.masterShiftId, text: item.namaShift + " - " + item.namaCabang };
            })
          : [];
      vm.listCuti.unshift({ value: null, text: "Day Off / Belum ada Jadwal" });
    },
    async getMitra() {
      let vm = this;
      let listCabang = await vm.$axios.post("cabang/listPerHalaman", {
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : [];
      // console.log("list cabang", vm.listCabang);
    },
    async reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      vm.filter.cabang = null;
      this.hitungTanggal();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
